import type { FC, ReactNode } from 'react'

import { FileText } from 'lucide-react'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PageHero } from '@/components/generals/page-hero'
import { siteConfig } from '@/constants/site'

const PrivacyPolicy: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Privacy policy'
                description="Privacy policy for Fernwell Counseling in Olympia, Washington."
            />

            <PageHero title="Privacy Policy" />

            <section id='policy' className='pb-20 sm:pb-28'>
                <div className='mx-auto max-w-3xl px-5 sm:px-8'>
                    <div className='flex flex-col gap-5 rounded-[2rem] border-2 border-dashed border-plum/25 bg-card p-8 sm:flex-row sm:p-10'>
                        <span className='grid size-14 shrink-0 place-items-center rounded-full bg-lavender text-plum'>
                            <FileText className='size-6' aria-hidden='true' />
                        </span>

                        <div className='space-y-4 text-lg leading-relaxed text-espresso-soft'>
                            <p className='font-heading text-2xl text-plum'>
                                This page is a placeholder.
                            </p>

                            <p>
                                Fernwell Counseling's full privacy policy is created by the practice using Termly and will replace this note before the site launches.
                            </p>

                            <p>
                                Questions in the meantime? Email{' '}
                                <a href={`mailto:${siteConfig.contact.email}`} className='break-words rounded-sm font-medium text-plum underline underline-offset-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum'>
                                    {siteConfig.contact.email}
                                </a>
                                .
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default PrivacyPolicy
